import Vue from 'vue'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'meta',
})
